<template>
	<article class="cts-wrap" v-if="userData">
    <div class="cts-actions">
      <md-field style="max-width: 200px;">
        <label>Fecha de deposito CTS</label>
        <v-date-picker v-model="depositAt" class="datepick" :formats="formats" popover-visibility="focus">
          <!-- :min-date="minDate" -->
          <!-- OJO -->
          <md-input slot-scope="{ inputValue }" style="text-align: left !important" :value="inputValue"
            readonly></md-input>
        </v-date-picker>
      </md-field>
      
      <md-button
        class="md-dense md-raised md-primary boleta__button-print"
        @click="calculateInteres"
      >
        Calcular Interés
      </md-button>
    </div>
    <div class="cts-actions">
      <md-field style="max-width: 150px;">
        <label>Monto Depositado</label>
        <md-input v-model.number="amount"></md-input>
      </md-field>
      <md-field style="max-width: 150px;">
        <label>Interés</label>
        <md-input v-model.number="interest"></md-input>
      </md-field>
      <md-field style="max-width: 200px;">
        <label>Tipo de cambio a Dólares</label>
        <md-input v-model.number="exchangeRate"></md-input>
      </md-field>
      <md-button
        class="md-dense md-raised md-primary boleta__button-print"
        @click="setCtsReal"
        :disabled="!isDataFull"
      >
        Guardar e imprimir
      </md-button>
    </div>
		<section class="cts-settlement">
			<section class="cts-settlement__header">
				<!-- <img src="" alt="logo empresa" class="logo" /> -->
				<h1>Liquidación de Depósito Semestral de CTS</h1>
				<p>
					{{ userData.business.name }}, con RUC N° {{ userData.business.ruc }}, domiciliado en
					{{ userData.business.address }}, representado por su {{ userData.business.legalRepresentativePosition }}, el Sr.
					{{ userData.business.legalRepresentative }}, en aplicación del artículo 24° del TUO del D.
					Leg. N° 650 Ley de Compensación por Tiempo de Servicios aprobada
					mediante el D.S. N° 001-97-TR, otorga a:
				</p>
				<p class="employee-name">
					<strong>{{ userData.employee.fullName }}</strong>
				</p>
				<p>
					La presente liquidación de depósito de CTS realizado el
					<span class="cts-date-hide">{{ dateFormatted }}</span>, en la cuenta:
				</p>
				<p>
					<strong
						>CTS N° {{ userData.bankAccountCts }} soles, del
						{{ userData.bankNameCts }}</strong
					>
				</p>
				<p>por los siguientes montos y periodos:</p>
			</section>
			<section class="cts-settlement__details">
				<section class="cts-settlement__period">
          <h2>1. Periodo que se liquida:</h2>
          <p>{{ctsPeriod}}</p>
        </section>
				<section class="cts-settlement__computed-amount">
          <h2>2. Remuneración Computable:</h2>
          <div class="cts__base-calc">
            <div class="cts__base-calc__item">
              <p>Básico</p>
              <p class="value">{{userData.grossSalary | currency}}</p>
            </div>
            <div class="cts__base-calc__item">
              <p>Asignación Familiar</p>
              <p class="value">{{userData.familyAssignment | currency}}</p>
            </div>
            <div class="cts__base-calc__item">
              <p>Gratificacón (1/6)</p>
              <p class="value">{{userData.resumeCts.periodGratCts | currency}}</p>
            </div>
            <div class="cts__base-calc__item">
              <p>Promedio de Comisiones</p>
              <p class="value">{{userData.resumeCts.promCommisions | currency}}</p>
            </div>
            <div class="cts__base-calc__item">
              <p>Promedio de Bonos</p>
              <p class="value">{{userData.resumeCts.promBonuses3in6 | currency}}</p>
            </div>
            <div class="cts__base-calc__total">
              <p>Total</p>
              <p class="value base-total-value">{{userData.resumeCts.rbcts | currency}}</p>
            </div>
          </div>
          <h3>CALCULO</h3>
          <div class="cts__base-calc">
            <div class="cts__base-calc__item-calc">
              <span>Por los meses completos:</span>
              <span>:12 x N° de meses</span>
              <span>{{(userData.resumeCts.workedAccumDays/30).toFixed(0)}}</span>
              <span class="value">{{(userData.resumeCts.rbcts / 12)*(Math.floor(userData.resumeCts.workedAccumDays/30)) | currency}}</span>
            </div>
            <div class="cts__base-calc__item-calc">
              <span>Por los días:</span>
              <span>:12 :30 x N° de días</span>
              <span> {{userData.resumeCts.workedAccumDays%30}} </span>
              <span class="value"> {{((userData.resumeCts.rbcts/12)/30)*(userData.resumeCts.workedAccumDays%30) | currency}} </span>
            </div>
            <!-- <div class="cts__base-calc__item-calc">
              <span>Intereses:</span>
              <span></span>
              <span></span>
              <span class="value underline"> {{ 0.03 | currency}} </span>
            </div> -->
          </div>
          <p class="total-cts">
            <span>TOTAL</span>
            <span>{{ ctsTotal | currency}}</span>
          </p>
          <p class="total-cts" v-if="interest">
            <span>INTERESES</span>
            <span>{{ interest | currency}}</span>
          </p>
          <p class="total-cts" v-if="interest">
            <span>TOTAL CON INTERESES</span>
            <span>{{ (interest + ctsTotal) | currency}}</span>
          </p>
          <p class="total-cts total-cts--deposit">
            <span>MONTO DEPOSITADO: S/</span>
            <span v-if="amount !== null">{{ amount | currency}}</span>
            <span v-else>____________________</span>
          </p>
          <p class="total-cts total-cts--deposit">
            <span v-if="exchangeRate !== null">MONTO DEPOSITADO: US$ (TIPO DE CAMBIO: {{ exchangeRate }})</span>
            <span v-else>MONTO DEPOSITADO: US$ (TIPO DE CAMBIO:__________)</span>
            <span v-if="amountUSD !== null"> {{ amountUSD | currencyUSD }} </span>
            <span v-else>___________________</span>
          </p>
        </section>
			</section>
      <p style="color: #ffffff;">
        {{ documentType[userData.employee.documentType] }}:{{
          userData.employee.documentNumber.trim()
        }}
      </p>
			<section class="cts-settlement__signature">
        <!-- <div></div> -->
        <div class="signature">
          <div></div>
          <p><strong>{{userData.employee.fullName}}</strong></p>
          <p><strong>Empleado</strong></p>
        </div>
        <!-- <div></div> -->
        <div class="signature">
          <div></div>
          <p><strong>{{ userData.business.legalRepresentative }}</strong></p>
          <p><strong>{{ userData.business.legalRepresentativePosition || 'Representante Legal' }}</strong></p>
        </div>
        <!-- <div></div> -->
      </section>
		</section>
	</article>
</template>

<script>
import dayjs from 'dayjs';
export default {
	name: "CtsSettlement",
	data() {
		return {
      months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"],
      depositAt: new Date(),
      userData: null,
      formats: {
        input: "D MMM YYYY",
      },
      amount: 0,
      exchangeRate: 0,
      realCtsId: null,
      // interest: 0,
      documentType: {
        "01": "DNI",
        "04": "CE",
        "07": "PPT",
        23: "PTP",
      },
      expiredFactor: 0,
      paymentFactor: 0
    };
	},
	computed: {
		businessName() {
			return this.$store.getters.actualBusiness.name;
		},
		businessRuc() {
			return this.$store.getters.actualBusiness.ruc;
		},
    businessAddress(){
      return this.$store.getters.actualBusiness.address;
    },
    businessContact(){
      return this.$store.getters.actualBusiness.contactPerson;
    },
    dateFormatted(){
      return this.dateFormat(this.depositAt);
    },
    ctsPeriod(){
      return this.ctsPeriodFormat(this.userData.resumeCts.actualPeriod);
    },
    isDataFull(){
      return this.amount !== null && this.exchangeRate !== null;
    },
    amountUSD(){
      if(this.amount === 0 || this.exchangeRate === 0) return null
      return (this.amount/(this.exchangeRate || 1)).toFixed(2)
    },
    expiredAt(){
      return this.getExpiredAtCts(this.userData.resumeCts.actualPeriod)
    },
    diffFactor(){
      return Math.abs(this.expiredFactor-this.paymentFactor);
    },
    ctsTotal(){
      return (this.userData.resumeCts.rbcts / 12)*(Math.floor(this.userData.resumeCts.workedAccumDays/30)) + ((this.userData.resumeCts.rbcts/12)/30)*(this.userData.resumeCts.workedAccumDays%30)
    },
    interest(){
      return Number((this.diffFactor*this.ctsTotal).toFixed(2))
    }
	},
  beforeCreate(){
    this.$store.dispatch("getEmployeeCts", {id: this.$route.params.id, query:`date=${this.$route.query.date}` }).then(res => {
      if(res.status === 200){
        this.userData = res.data;
        this.$store.dispatch("getEmployeeCtsReal", {id: this.$route.params.id, query:`date=${this.$route.query.date}` }).then(res => {
          if(res.status === 200){
            if(res.data !== null){
              this.realCtsId = res.data.id;
              this.amount = res.data.amount || 0;
              this.depositAt = res.data.depositAt ? new Date(res.data.depositAt) : new Date();
              this.exchangeRate = res.data.exchangeRate || 0;
              this.interest = res.data.interest;
            }
          }
        })
      }
    })
  },
  methods:{
    dateFormat(value){
      const day = new Date(value).getDate();
      const month = new Date(value).getMonth();
      const year = new Date(value).getFullYear();

      return `${day} de ${this.months[month]} del ${year}`;
    },
    ctsPeriodFormat(value){
      const month = new Date(this.$route.query.date).getMonth();
      const year = new Date(this.$route.query.date).getFullYear();
      if(value==='novAbr'){
        const yearStart = [10,11].includes(month) ? year : year - 1;
        const yearEnd = [10,11].includes(month) ? year + 1 : year;
        return `Del 1 de Noviembre de ${yearStart} al 30 Abril de ${yearEnd}`
      }else if(value === 'mayOct'){
        const yearStart = year;
        const yearEnd = year;
        return `Del 1 de Mayo de ${yearStart} al 31 de Octubre de ${yearEnd}`
      }
    },
    getExpiredAtCts(value){
      const month = new Date(this.$route.query.date).getMonth();
      const year = new Date(this.$route.query.date).getFullYear();
      if(value==='novAbr'){
        const yearEnd = [10,11].includes(month) ? year + 1 : year;
        return dayjs().year(yearEnd).month(4).date(15).toISOString()
      }else if(value === 'mayOct'){
        const yearEnd = year;
        return dayjs().year(yearEnd).month(11).date(15).toISOString()
      }
    },
    print() {
      window.print();
    },
    async setCtsReal(){
      if(this.realCtsId){
        const res = await this.$store.dispatch('setEmployeeCtsReal', {
          id: this.$route.params.id,
          body: {
            amount: this.amount,
            exchangeRate: this.exchangeRate,
            depositAt: new Date(this.depositAt).toISOString(),
            id: this.realCtsId,
            interest: this.interest
          }
        })
        if(res.status === 200){
          print();
        }
        console.log(res);
      } else {
        this.$toasted.error("No hay CTS creada para este periodo aún. No se puede guardar los datos")
      }
    },
    async calculateInteres(){
      const today = dayjs().startOf("day")
      const depositAt = dayjs(this.depositAt).isBefore(today) ? dayjs(this.depositAt).startOf('day').toISOString() : dayjs(this.depositAt).subtract(1, 'day').startOf('day').toISOString()
      const res = await this.$store.dispatch("getInteresCTS",{
        id: this.$route.params.id,
        expiredAt: dayjs(this.expiredAt).startOf('day').toISOString(),
        depositAt: depositAt
      })
      this.expiredFactor = res.data.initFactor.nationalAccumFactor;
      this.paymentFactor = res.data.endFactor.nationalAccumFactor;
    }
  }
};
</script>

<style lang="scss" scoped>

.cts-wrap {
  padding: 5%;
  background-color: #eceff8;
}
.cts-settlement {
  background-color: #fff;
  padding: 1.5rem;
  &__header{
    h1 {
      margin: 0 0 1em;
      font-size: 1.5rem;
      text-align: center;
    }
    p {
      font-size: 1rem;
      margin: 1.2em 0;
      &.employee-name {
        text-transform: uppercase;
      }
    }
  }
  
  &__period, &__computed-amount {
    h2 {
      font-size: 1.1rem;
      margin: 1em 0;
    }
    h3 {
      font-size: 1rem;
      margin: 1em 0;
    }
  }
  &__computed-amount {
    .cts__base-calc {
      padding: 0.8rem 1.5rem;
      &__item, &__total {
        display: grid;
        grid-template-rows: auto;
        grid-template-columns: 1fr 100px;
        margin: 0.2rem 0;
        .base-total-value {
          border-top: thin solid #000;
          border-bottom: thin solid #000;
        }
      }
      &__item-calc {
        display: grid;
        grid-template-rows: auto;
        grid-template-columns: 1fr 1fr 1fr 100px;
        
        .underline {
          border-bottom: thin solid #000;
        }
      }
      .value {
        text-align: end;
      }
    }
    .total-cts {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 1.5rem;
      margin: 1em 0;
      font-weight: bold;
      font-size: 1rem;
    }
    .total-cts--deposit{
      margin-top: 2rem;
    }

  }
  &__signature {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 2fr 2fr;
    gap: 4rem;
    .signature {
      display: grid;
      grid-template-rows: 150px repeat(2, minmax(30px, 1fr));
      p {
        text-align: center;
      }
    }
  }
}
// .cts-date-hide {
//   color: transparent;
//   text-decoration: underline solid #000;
// }
.cts-actions {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.icon-button {
  height: 1.5rem;
  width: auto;
  margin: 0 0.5rem;
}

@media print {
  @page {
    size: A4;
    margin: 1cm 2cm;
  }
  .cts-wrap {
    background-color: #ffffff !important;
    padding: 1rem !important;
    font-size: 10pt !important;
  }
  .total-cts {
    font-size: 11pt !important;
  }
  .cts-actions {
    display: none !important;
  }
  .cts-settlement {
    max-width: 210mm;
  }
  .cts-settlement__signature {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 2fr 2fr;
    gap: 4rem;
    .signature {
      display: grid;
      grid-template-rows: 120px repeat(2, minmax(30px, 1fr));
      p {
        text-align: center;
      }
    }
  }
}
</style>